/** @jsx h */
import { FunctionalComponent, h } from 'preact';
import { IItemModel, ItemTypes } from '../../../../models/Item';
import { IMenuItemModel } from '../../../../models/Menu';
import {
  E2E,
  getDataTestIdSuffix,
  getTestID,
  useE2ETesting,
} from '../../../../providers/e2eTestingProvider';
import { ItemIcon } from '../../desktopNavStyled';
import { FooterItem } from './footerLinkStyled';
import AppLink from '../../../appLink';

export interface IFooterLinkProps {
  item: IMenuItemModel;
  onClick?(event: Event): void;
  isBottomItem?: boolean;
  isBold?: boolean;
}

const FooterLink: FunctionalComponent<IFooterLinkProps> = ({
  item,
  onClick,
  isBottomItem,
  isBold,
}) => {
  const { testIdPrefix } = useE2ETesting();
  const itemModel = item as IItemModel;
  const { anchorText, itemName, menuImageUrl, itemType } = itemModel;
  const isFeaturedLink = itemType === ItemTypes.featuredLink;

  const elementTypeID = !!menuImageUrl ? E2E.component.icon : E2E.component.link;
  const testIdValue = getTestID(testIdPrefix, elementTypeID, getDataTestIdSuffix(itemName));

  return (
    <FooterItem isBottomItem={isBottomItem} isBold={isBold} isFeaturedLink={isFeaturedLink}>
      <AppLink item={itemModel} onClick={onClick} data-testid={testIdValue}>
        {menuImageUrl && (
          <ItemIcon alt={itemName || anchorText} src={menuImageUrl} hasContent={!!anchorText} />
        )}
        {anchorText}
      </AppLink>
    </FooterItem>
  );
};

export default FooterLink;
